export enum NgxMatTimepickerPeriods {
    AM = "AM",
    PM = "PM"
}
